import { render, staticRenderFns } from "./Alphabets.vue?vue&type=template&id=04b8515a&scoped=true"
import script from "./Alphabets.vue?vue&type=script&lang=js"
export * from "./Alphabets.vue?vue&type=script&lang=js"
import style0 from "./Alphabets.vue?vue&type=style&index=0&id=04b8515a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8515a",
  null
  
)

export default component.exports